<template>
  <div>
    <Logo></Logo>
    <h2 class="shareholder-hd">관계사 프로모션 혜택 인증</h2>
    <p class="shareholder-explain">
      <span>관계사 프로모션 혜택 적용을 위해</span>
      <span>이메일 인증을 진행합니다.</span>
    </p>
      <div class="input-wrap">
        <label>
          <select name="group-select" class="input-style01" v-model="selectedGroupCode">
            <option value="" selected disabled>그룹 선택</option>
            <template v-if="groupList.length > 0">
              <option v-for="({ groupcode, groupname }, groupIndex) in groupList" :key="groupcode + '_' + groupIndex" :value="groupcode">{{groupname}}</option>
            </template>
          </select>
        </label>
      </div>
      <div class="input-wrap">
        <label>
          <select name="subsidiary-select" class="input-style01" v-model="selectedMemberCode" @click="checkGroupCode">
            <option value="" selected disabled>회사 선택</option>
            <option v-for="({membercode, membername}, index) in memberList" :key="membercode + '_' + index" :value="membercode">{{membername}}</option>
          </select>
        </label>
      </div>
      <div class="input-wrap domain-input-wrap">
        <label>
          <input type="text" class="input-style01"
                 v-model="emailPrefix"
                 :disabled="selectedMemberCode === ''"
                 @keydown="onKeyDownFromEmail"
          >
        </label>
        <span class="domain-text">{{selectedDomain}}</span>
      </div>
      <div class="btn-verification-code-wrap">
        <button type="button" class="btn-verification-code" @click.prevent="sendAuthCode"> 인증번호 {{authCodeSendStatus ? '재전송' : '전송'}}</button>
      </div>
      <div class="input-wrap" v-if="authCodeSendStatus">
        <label>
          <input type="number"
                 class="input-style01"
                 placeholder="인증번호"
                 v-model="userAuthCode"
                 @keydown="onKeyDownFromSubmit"
          >
        </label>
      </div>
      <div class="button-wrap" v-if="authCodeSendStatus">
        <input type="submit" @click.prevent="submitAuthCode" value="확인">
      </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import Logo from '@/views/partners/Logo'
import { PartnersService } from '@/common/api/api.service'
import { PATH_NAME_VOUCHER } from '@/common/router.const'

export default {
  name: 'PartnersHome',
  components: {
    Logo
  },
  data () {
    return {
      groupList: [],
      selectedGroupCode: '',
      memberList: [],
      selectedMemberCode: '',
      selectedDomain: '',
      emailPrefix: '',
      authCodeSendStatus: false,
      userAuthCode: ''
    }
  },
  methods: {
    checkGroupCode () {
      if (this.selectedGroupCode === '') {
        alert('그룹을 선택해 주세요.')
      }
    },
    onKeyDownFromEmail (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault()
        this.sendAuthCode()
      }
    },
    onKeyDownFromSubmit (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault()
        this.submitAuthCode()
      }
    },
    setGroupData () {
      PartnersService.getList().then(({ data }) => {
        this.groupList = get(data, 'list', [])
      })
    },
    validateEmail () {
      if (this.selectedGroupCode === '') {
        alert('그룹을 선택해 주세요.')
        return false
      } else if (this.selectedMemberCode === '') {
        alert('회사를 선택해 주세요.')
        return false
      } else if (this.emailPrefix === '' || this.selectedDomain === '') {
        alert('이메일을 입력해 주세요.')
        return false
      }
      return true
    },
    validateAuthCode () {
      if (this.userAuthCode === '') {
        alert('인증번호를 입력해 주세요.')
        return false
      }
      return true
    },
    sendAuthCode () {
      if (this.validateEmail()) {
        const userEmail = this.emailPrefix + this.selectedDomain
        PartnersService.regist({
          groupcode: this.selectedGroupCode,
          email: userEmail,
          membercode: this.selectedMemberCode
        }, (err) => {
          console.log('ERROR : ', err)
        }).then(({ data }) => {
          const { resultcode, resultmessage } = data
          if (resultcode === '200' || resultcode === 200) {
            if (resultmessage === 'success') {
              alert(userEmail + '으로\n인증번호가 전송되었습니다.\n인증번호 전송까지 시간이 소요되거나 지연될 수 있습니다.\n\n' +
                '계속해서 인증번호가 수신되지 않을 경우 이메일 주소를 확인해 주시고 재전송하시거나, 스팸 메일로 분류 될 수 있으니 스팸 메일함을 확인해 주세요.')
              this.authCodeSendStatus = true
            } else if (resultmessage === 'pass') {
              this.$router.replace({ name: PATH_NAME_VOUCHER, query: { promotioncode: 'forholder' } })
            }
          } else {
            alert(resultmessage)
          }
        }).catch(() => {
          alert('현재 인증 번호 발송이 불가능 합니다.')
        })
      }
    },
    submitAuthCode () {
      if (this.validateAuthCode()) {
        PartnersService.authenticate({ email: this.emailPrefix + this.selectedDomain, authenticatecode: this.userAuthCode }).then(({ data }) => {
          const { resultcode, resultmessage } = data
          if ((resultcode === '200' || resultcode === 200) && resultmessage === 'success') {
            this.$router.replace({ name: PATH_NAME_VOUCHER, query: { promotioncode: 'forholder' } })
          } else {
            alert(resultmessage)
          }
        }).catch(() => {
          alert('인증에 실패 했습니다.')
        })
      }
    },
    setMemberList (groupCode) {
      const selectedGroup = this.groupList.filter((group) => {
        return groupCode === get(group, 'groupcode', '')
      })
      this.memberList = get(selectedGroup, '0.memberlist', [])
    },
    setMemberDomain (memberCode) {
      const selectedMember = this.memberList.filter((member) => {
        return memberCode === get(member, 'membercode', '')
      })
      this.selectedDomain = get(selectedMember, '0.memberemaildomain', '')
    },
    reset () {
      this.memberList = []
      this.selectedMemberCode = ''
      this.selectedDomain = ''
      this.emailPrefix = ''
    }
  },
  created () {
    this.setGroupData()
  },
  mounted () {
  },
  watch: {
    selectedGroupCode (newGroupCode, oldGroupCode) {
      if (newGroupCode !== oldGroupCode) {
        this.reset()
        this.setMemberList(newGroupCode)
      }
    },
    selectedMemberCode (newMemberCode, oldMemberCode) {
      if (newMemberCode !== oldMemberCode) {
        this.setMemberDomain(newMemberCode)
      }
    }
  }
}

</script>
<style>

</style>
